import { render, staticRenderFns } from "./conferencebillingsecretariart.vue?vue&type=template&id=10e2a972"
import script from "./conferencebillingsecretariart.vue?vue&type=script&lang=js"
export * from "./conferencebillingsecretariart.vue?vue&type=script&lang=js"
import style0 from "./conferencebillingsecretariart.vue?vue&type=style&index=0&id=10e2a972&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports